import StoreAction from "../../../../constants/store-action";
import { validateStringNumberInRange } from "../../../../utils/validation";
const createHouseholdChildrenField = (store, isValid, setIsValid) => {
    const value = store.data.householdEconomy.householdChildren;
    const update = (newValue) => store.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
        type: "householdEconomy",
        name: "householdChildren",
        value: newValue,
    });
    const validate = () => {
        const isValid = validateStringNumberInRange(value, 0, 999);
        setIsValid(isValid);
    };
    const field = {
        value,
        displayError: !isValid,
        onChange: update,
        onFinish: validate,
    };
    return field;
};
export default createHouseholdChildrenField;
